import { PAGE_HEADER_HEIGHT } from "@digits-shared/components/UI/Elements/Container"
import { H2 } from "@digits-shared/components/UI/Elements/Header"
import { isDigitsMacApp } from "@digits-shared/helpers/devicesHelper"
import borders from "@digits-shared/themes/borders"
import colors from "@digits-shared/themes/colors"
import fonts from "@digits-shared/themes/typography"
import styled, { css } from "styled-components"

// USE IT AT YOUR OWN RISK!
// this margin is wrong and wont work with new headers, only when using <LegacyApplicationHeader>
export const LEGACY_TOP_MARGIN = isDigitsMacApp ? 135 : 111

export const LegacyPageHeader = styled.header`
  width: var(--application-pane-width);
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
  padding: 10px 0 16px;
  border-top-left-radius: ${borders.radius.default}px;
  border-top-right-radius: ${borders.radius.default}px;
  text-transform: uppercase;
  color: ${colors.secondary};
  height: ${PAGE_HEADER_HEIGHT}px;
  min-height: ${PAGE_HEADER_HEIGHT}px;

  ${isDigitsMacApp &&
  css`
    height: ${PAGE_HEADER_HEIGHT + 40}px;
    min-height: ${PAGE_HEADER_HEIGHT + 40}px;
  `}
`

export const LegacyPageHeaderTitle = styled(H2)`
  text-transform: none;
  margin: 2px 0;
  line-height: 22px;
  font-weight: ${fonts.weight.black};
  font-size: 20px;
  color: ${colors.secondary};
`
